import { AgreementResult, Mutation } from 'graphql/generated/graphqlTypes';

export function mockedAcceptLegalDocumentsData(
  acceptLegalDocuments: AgreementResult
): Pick<Mutation, 'acceptLegalDocuments'> {
  return {
    acceptLegalDocuments
  };
}

export const mockedAcceptLegalDocumentsDataForMutation1 = mockedAcceptLegalDocumentsData({
  __typename: 'BasicTenant',
  tenantId: 'mockedTenantId',
  name: 'mockedTenantName',
  onboardingStep: 'mockedOnboardingStep'
});

export const mockedAcceptLegalDocumentsDataForMutation2 = mockedAcceptLegalDocumentsData({
  __typename: 'AgreementRejected',
  reason: 'AgreementRejectedReason'
});
